import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Generate from "@/pages/Generate";
import PlanView from "@/pages/PlanView";
import MyPlans from "@/pages/MyPlans";
import ContactUs from "@/pages/legal/ContactUs";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Refunds from "@/pages/legal/Refunds";
import Shipping from "@/pages/legal/Shipping";
import RouteTracker from "@/components/RouteTracker";

export default function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/generate" element={<Generate />} />
          <Route path="/plan/:id" element={<PlanView />} />
          <Route path="/plans" element={<MyPlans />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refunds" element={<Refunds />} />
          <Route path="/shipping" element={<Shipping />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
